import {Condition, type Journey} from "../engine/Condition.js";

export interface InactiveOptions {
    seconds: number;
}

export class InactiveCondition extends Condition<InactiveOptions> {
    isInactive = false;

    constructor(journey: Journey, options: InactiveOptions, requestReEval: () => void) {
        super(journey, options, requestReEval);

        let inactiveTimeout: ReturnType<typeof setTimeout> | null = null;
        const resetInactiveStatus = () => {
            this.isInactive = false;
            clearTimeout(inactiveTimeout);
            inactiveTimeout = this.attachTimeout(() => {
                this.isInactive = true;
                this.requestReEval();
            }, this.options.seconds * 1000);
        }

        resetInactiveStatus();
        this.attachEventListener(window, "mousemove", resetInactiveStatus);
        this.attachEventListener(window, "scroll", resetInactiveStatus);
        this.attachEventListener(window, "click", resetInactiveStatus);
    }

    evaluate() {
        return this.isInactive;
    }
}
